module.exports = __webpack_public_path__ + "img/Billionaire-5.7e315007.png";